import React from "react";
import AttendanceView from "../views/AttendanceView";
import CounselingView from "../views/CounselingView";

export function renderAttendanceMenuContent({
    students,
    teachers,
    updateItem,
    deleteItem,
    incrementStat,
    checkAndAwardBadges,
    visitLogs,
    attendanceLogs,
    targetDate,
    setTargetDate,
    tourAction,
    attendanceSearchQuery,
    setAttendanceSearchQuery,
    attendanceTargetGroup,
    setAttendanceTargetGroup,
    selectedDepartment,
    currentTheme,
    refreshAttendanceLogs,
    userProfile
}) {
    return (
        <AttendanceView
            students={students}
            teachers={teachers}
            onUpdate={(d) => updateItem("students", d.id, d)}
            onDelete={(id) => deleteItem("students", id)}
            onSaveAttendance={(count) => {
                if (incrementStat) {
                    incrementStat("attendance_count", count);
                    checkAndAwardBadges();
                }
            }}
            visitLogs={visitLogs}
            attendanceLogs={attendanceLogs}
            initialDate={targetDate}
            onClearTargetDate={() => setTargetDate(null)}
            demoAction={tourAction === "demo_attendance"}
            searchQuery={attendanceSearchQuery}
            setSearchQuery={setAttendanceSearchQuery}
            targetGroup={attendanceTargetGroup}
            setTargetGroup={setAttendanceTargetGroup}
            selectedDepartment={selectedDepartment}
            theme={currentTheme}
            onRefreshLogs={refreshAttendanceLogs}
            userProfile={userProfile}
        />
    );
}

export function renderCounselingMenuContent({
    students,
    teachers,
    visitLogs,
    attendanceLogs,
    addItem,
    deleteItem,
    updateItem,
    targetStudentId,
    targetLogId,
    setTargetLogId,
    counselingSearchQuery,
    setCounselingSearchQuery,
    counselingTargetGroup,
    setCounselingTargetGroup,
    selectedDepartment,
    user,
    userProfile,
    currentTheme
}) {
    return (
        <CounselingView
            students={students}
            teachers={teachers}
            visitLogs={visitLogs}
            attendanceLogs={attendanceLogs}
            onAddLog={(d) => addItem("visitLogs", d)}
            onDeleteLog={(id) => deleteItem("visitLogs", id)}
            onUpdateLog={(d) => updateItem("visitLogs", d.id, d)}
            initialStudentId={targetStudentId}
            initialLogId={targetLogId}
            onClearTargetLogId={() => setTargetLogId(null)}
            onUpdateStudent={(d) => updateItem("students", d.id, d)}
            searchQuery={counselingSearchQuery}
            setSearchQuery={setCounselingSearchQuery}
            targetGroup={counselingTargetGroup}
            setTargetGroup={setCounselingTargetGroup}
            selectedDepartment={selectedDepartment}
            user={user}
            userProfile={userProfile}
            theme={currentTheme}
        />
    );
}
